import React from "react";
import background_image from "./images/movietheatresbg.png";
import seats from "./images/seats.png";
import SectionTwo from "02Section";

export default function Header() {
  return (
    <div className="section-one__con">
      <div
        className="section-one__image bg"
        style={{ backgroundImage: `url(${background_image})` }}
      ></div>
      <div
        className="section-one__image seats"
        style={{ backgroundImage: `url(${seats})` }}
      ></div>
      <div className="section-one__workingarea">
        {/* <div className="cs">
        RU Hacks 2022 <br/>COMING SOON</div>
       </div> */}

        <SectionTwo />
      </div>
    </div>
  );
}
